import { render, staticRenderFns } from "./softwareOilfieldMobile.vue?vue&type=template&id=d635ed26&scoped=true"
import script from "./softwareOilfieldMobile.vue?vue&type=script&lang=js"
export * from "./softwareOilfieldMobile.vue?vue&type=script&lang=js"
import style0 from "./softwareOilfieldMobile.vue?vue&type=style&index=0&id=d635ed26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d635ed26",
  null
  
)

export default component.exports